import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';
import { LocalizedContentShow } from '../../components/LocalizedContentTabs';

interface BadgeDto {
  id: string;
  name: string;
  description?: string | null;
  translations?: Record<string, { name?: string; description?: string }> | null;
  imageUrl?: string | null;
  priceCoins: number;
  category?: string | null;
  tier?: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const tagStyle = (color: string) => ({
  borderColor: color,
  color,
  background: `${color}15`,
  borderRadius: 9999,
  padding: '2px 12px',
  fontWeight: 500,
});

export const BadgeShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<BadgeDto>({ resource: 'badges' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="badges">
      <div style={{ padding: '8px 0' }}>
        <LocalizedContentShow
          record={item}
          fields={[
            { key: 'name', label: 'Name' },
            { key: 'description', label: 'Description', textarea: true },
          ]}
        />

        <div
          style={{
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            paddingTop: 16,
          }}
        >
          {item.imageUrl && (
            <Field label="Image">
              <a href={item.imageUrl} target="_blank" rel="noreferrer">{item.imageUrl}</a>
            </Field>
          )}
          <Field label="Price (Coins)">{item.priceCoins}</Field>
          {item.category && (
            <Field label="Category">
              <Tag style={tagStyle('#1890ff')}>{item.category}</Tag>
            </Field>
          )}
          {item.tier && (
            <Field label="Tier">
              <Tag style={tagStyle('#f5a623')}>{item.tier}</Tag>
            </Field>
          )}
          <Field label="Sort Order">{item.sortOrder}</Field>
          <Field label="Active">
            <Tag style={tagStyle(item.isActive ? '#3ecf8e' : '#898989')}>
              {item.isActive ? 'Active' : 'Inactive'}
            </Tag>
          </Field>
          <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
          <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
        </div>
      </div>
    </Show>
  );
};
